/// <amd-module name="Pipeline/Analytics/PipelineOutcome/FailureTrendCard/Actions/PipelineOutcomeFailureTrendActionsCreator" />
import { IReportContext } from "Analytics/Shared/Common/Types";
import { ITrendChartReportConfiguration } from "Analytics/Shared/TrendChart/Common/Types";
import { PipelineOutcomeFailureTrendActions } from "Pipeline/Analytics/PipelineOutcome/FailureTrendCard/Actions/PipelineOutcomeFailureTrendActions";
import { PipelineOutcomeFailureTrendSource } from "Pipeline/Analytics/PipelineOutcome/FailureTrendCard/Sources/PipelineOutcomeFailureTrendSource";
import { IVssPageContext } from "VSS/Platform/Context";

export class PipelineOutcomeFailureTrendActionsCreator {
    private _pipelineFailureTrendSource: PipelineOutcomeFailureTrendSource;

    constructor(private _actions: PipelineOutcomeFailureTrendActions, private _pageContext: IVssPageContext) {
        this._pipelineFailureTrendSource = new PipelineOutcomeFailureTrendSource(_pageContext);
    }

    public updateConfigurationValues(reportContext: IReportContext, newConfValues: ITrendChartReportConfiguration): Promise<void> {
        this._actions.updateConfigurationValuesAction.invoke(newConfValues);
        return this.updateFailingStageAndTaskData(reportContext, newConfValues);
    }

    public async updateFailingStageAndTaskData(reportContext: IReportContext, confValues: ITrendChartReportConfiguration): Promise<void> {
        try {
            const topFailingStageAndTaskData = await this._pipelineFailureTrendSource.queryFailingStageAndTaskData(reportContext, confValues);
            this._actions.updateFailingStageAndTaskDataAction.invoke(topFailingStageAndTaskData);
        } catch (error) {
            this._actions.onError.invoke(error);
            return Promise.reject(error);
        }
    }
}
